export default __webpack_public_path__ + "static/media/add_photo_alternate.1fe8d39d.svg";